
import { MutationsService } from '@vedicium/object-mutations';
import Vue, { PropType } from 'vue';
import { APP_ERROR_EVENT } from '../../../../../constants';
import { Core } from '../../../../../services/core';

import { ColorPartEntity, ColorPartsStore } from '../../../../../services/parts';
import { PartsColorsSublinesForm } from '../components';

export default Vue.extend({
  name: 'partsColorsViewManufacturing',
  components: {
    PartsColorsSublinesForm,
  },
  props: {
    color: {
      type: Object as PropType<ColorPartEntity>,
    },
  },
  data() {
    return {
      isLoadingForm: false,

      metadata: {
        color: JSON.parse(JSON.stringify(this.color)) as ColorPartEntity,
      },
    };
  },

  methods: {
    onAddSublineClick(): void {
      (this.$refs.sublinesForm as any).onAddSubline();
    },
    async onSublinesUpdate(): Promise<void> {
      try {
        await this.onSubmit();
      } catch (e) {
        this.$set(this.metadata, 'color', JSON.parse(JSON.stringify(this.color)));
      }
    },

    async onSubmit() {
      this.$set(this, 'isLoadingForm', true);
      try {
        const mutations = MutationsService.getMutationsByComparison(
          this.color,
          this.metadata.color,
          ['manufacturing.sublines'],
        );

        if (mutations.length > 0) {
          const entity = await ColorPartsStore.update(this.color._meta.guid, mutations);

          this.$emit('update:color', entity);
          this.$set(this.metadata, 'color', JSON.parse(JSON.stringify(entity)));
        }

        this.$bvToast.toast('Document successfully updated', {
          title: 'Update successful',
          variant: 'success',
          solid: true,
        });
      } catch (e) {
        Core.Eventhub.emit(APP_ERROR_EVENT, e);
        console.error(e);
        throw e;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }
    },
  },
});
